import { render, staticRenderFns } from "./collegeList.vue?vue&type=template&id=bf9d14e2&scoped=true"
import script from "./collegeList.vue?vue&type=script&lang=js"
export * from "./collegeList.vue?vue&type=script&lang=js"
import style0 from "./collegeList.vue?vue&type=style&index=0&id=bf9d14e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d14e2",
  null
  
)

export default component.exports